import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4fc63638")

_pushScopeId("data-v-4fc63638")
const _hoisted_1 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item_divider = _resolveComponent("ion-item-divider")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_item_option = _resolveComponent("ion-item-option")!
  const _component_ion_item_options = _resolveComponent("ion-item-options")!
  const _component_ion_item_sliding = _resolveComponent("ion-item-sliding")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_header, null, {
        default: _withId(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withId(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": "/tabs/guests",
                    text: _ctx.$t('Back')
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "primary" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_button, {
                    onClick: _withModifiers(_ctx.onAddClicked, ["prevent"])
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "end",
                        icon: _ctx.addCircleOutline
                      }, null, 8, ["icon"]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("Add Guest")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, null, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("Guests")), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode(_component_ion_searchbar, {
            modelValue: _ctx.term,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.term = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_ion_list, null, {
            default: _withId(() => [
              _createVNode(_component_ion_item_divider, { class: "ion-text-center" }, {
                default: _withId(() => [
                  _createVNode(_component_ion_select, {
                    modelValue: _ctx.status,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.status = $event))
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.guestStatuses.values(), (guestStatus) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: guestStatus.statusId,
                          value: guestStatus.statusId
                        }, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(guestStatus.title), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128)),
                      _createVNode(_component_ion_select_option, { value: -1 }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("All")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_ion_select, {
                    modelValue: _ctx.sortBy,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortBy = $event)),
                    slot: "end"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_ion_select_option, { value: "table" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("by Table")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_select_option, { value: "last_name" }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("by Last Name")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredGuests, (guest) => {
                return (_openBlock(), _createBlock(_component_ion_item_sliding, {
                  key: guest.id
                }, {
                  default: _withId(() => [
                    _createVNode(_component_ion_item, {
                      button: "",
                      onClick: ($event: any) => (_ctx.onItemClicked(guest.id)),
                      lines: "full",
                      detail: "false"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withId(() => [
                            _createTextVNode(_toDisplayString(guest.first_name + " " + guest.last_name) + " ", 1),
                            (guest.matchesKey)
                              ? (_openBlock(), _createBlock("p", _hoisted_1, _toDisplayString(guest.matchesKey + ": " + guest.matchesValue), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_icon, {
                          icon: _ctx.guestStatusById(guest.invited).icon,
                          color: _ctx.guestStatusById(guest.invited).color,
                          slot: "start"
                        }, null, 8, ["icon", "color"]),
                        (guest.table)
                          ? (_openBlock(), _createBlock(_component_ion_note, {
                              key: 0,
                              slot: "end"
                            }, {
                              default: _withId(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('Table ')) + _toDisplayString(guest.table), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_item_options, { side: "end" }, {
                      default: _withId(() => [
                        _createVNode(_component_ion_item_option, {
                          color: "primary-contrast",
                          onClick: ($event: any) => (_ctx.onDeleteClicked(guest.id))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_ion_icon, {
                              icon: _ctx.trashOutline,
                              color: "danger",
                              style: {"font-size":"30px"}
                            }, null, 8, ["icon"])
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})